import { Link } from "react-router-dom";
import { Heart, Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin, Youtube } from "lucide-react";

// Official Blue vs Blue Logo
const LOGO_URL = "https://customer-assets.emergentagent.com/job_6cd70ab0-164b-4026-90ab-4bbce9b2006d/artifacts/koo5s91n_BluevsBlue1%20%281%29.png";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="space-y-4">
            <img 
              src={LOGO_URL} 
              alt="Blue vs Blue" 
              className="h-16 w-auto rounded"
            />
            <p className="text-slate-400 text-sm leading-relaxed">
              Blue vs Blue Prostate Cancer Awareness Organization is dedicated to bringing prostate cancer awareness to first responders and communities across the United States.
            </p>
            <div className="flex gap-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-awareness-blue transition-colors" data-testid="social-facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-awareness-blue transition-colors" data-testid="social-twitter">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-awareness-blue transition-colors" data-testid="social-instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-awareness-blue transition-colors" data-testid="social-linkedin">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-awareness-blue transition-colors" data-testid="social-youtube">
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4 uppercase tracking-wide">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-slate-400 hover:text-white transition-colors text-sm" data-testid="footer-about">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/events" className="text-slate-400 hover:text-white transition-colors text-sm" data-testid="footer-events">
                  Events
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-slate-400 hover:text-white transition-colors text-sm" data-testid="footer-blog">
                  News & Updates
                </Link>
              </li>
              <li>
                <Link to="/get-involved" className="text-slate-400 hover:text-white transition-colors text-sm" data-testid="footer-get-involved">
                  Get Involved
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-white transition-colors text-sm" data-testid="footer-contact">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Get Involved */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4 uppercase tracking-wide">Get Involved</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/donate" className="text-slate-400 hover:text-white transition-colors text-sm" data-testid="footer-donate">
                  Donate
                </Link>
              </li>
              <li>
                <Link to="/get-involved" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Volunteer
                </Link>
              </li>
              <li>
                <Link to="/get-involved" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Become a Sponsor
                </Link>
              </li>
              <li>
                <Link to="/get-involved" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Partner With Us
                </Link>
              </li>
              <li>
                <Link to="/events" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Attend Events
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4 uppercase tracking-wide">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-slate-400 text-sm">
                <Mail className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <a href="mailto:PCA@bluevsblue.org" className="hover:text-white transition-colors">
                  PCA@bluevsblue.org
                </a>
              </li>
              <li className="flex items-start gap-3 text-slate-400 text-sm">
                <Phone className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <a href="tel:+13178405667" className="hover:text-white transition-colors">
                  (317) 840-5667
                </a>
              </li>
              <li className="flex items-start gap-3 text-slate-400 text-sm">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <span>8401 Moller Rd, Unit 78061<br/>Indianapolis, IN 46268</span>
              </li>
            </ul>
            
            <div className="mt-6">
              <Link to="/donate" data-testid="footer-donate-btn">
                <button className="bg-awareness-blue text-slate-900 hover:bg-[#5aa0d1] font-semibold px-6 py-3 rounded-md transition-colors flex items-center gap-2">
                  <Heart className="w-4 h-4" />
                  Donate Now
                </button>
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm text-center md:text-left">
              © {currentYear} Blue vs Blue. All rights reserved.
            </p>
            <div className="flex items-center gap-2 bg-slate-800 px-4 py-2 rounded-md">
              <span className="text-awareness-blue font-semibold text-sm">501(c)(3)</span>
              <span className="text-slate-400 text-sm">Tax-Exempt Nonprofit Organization</span>
            </div>
          </div>
          <p className="text-slate-500 text-xs text-center mt-4">
            Blue vs Blue is a 501(c)(3) nonprofit organization. All donations are tax-deductible to the extent allowed by law.
          </p>
        </div>
      </div>
    </footer>
  );
}
